import React from 'react';
import { CellTemplateProps, ColumnProps } from 'fulogics-ui-web';
import GridColumnInspectorHelper from 'fulogics-ui-web/dist/layout/dx/DataGrid/helpers/GridColumnInspectorHelper';
import StateOrderSimpleText, {
    StateOrderSimpleTextData,
    StateOrderSimpleTextDataKeys,
    StateOrderSimpleTextDisplayOptions,
} from '../../../../components/state-order-simple-text/StateOrderSimpleText';

const StateOrderSimpleTextColumnTemplate = (props: CellTemplateProps) => (
    <GridColumnInspectorHelper cellProps={props}>
        {(inspectorId, disableInspectorForm) => (
            <StateOrderSimpleText
                disableInspectorForm={disableInspectorForm}
                inspectorId={inspectorId}
                data={props?.data}
                defaultProps={StateOrderSimpleTextColumnTemplateDefaultProps}
            />
        )}
    </GridColumnInspectorHelper>
);

export const StateOrderSimpleTextColumnTemplateDefaultProps =
    {} as StateOrderSimpleTextDisplayOptions;

export const StateOrderSimpleTextColumnTemplatePredProps = (current: ColumnProps): ColumnProps => ({
    ...current,
});

export type StateOrderSimpleTextColumnTemplateData = StateOrderSimpleTextData & {};

export const StateOrderSimpleTextColumnTemplateDataKeys = [...StateOrderSimpleTextDataKeys];

export default StateOrderSimpleTextColumnTemplate;
